import React from "react";
import Table from "react-bootstrap/Table";
import business from "../assets/business.png";
import view from "../assets/view.png";
import del from "../assets/del.png";
import star from "../assets/star.png";
import edit from "../assets/edit.png";
import { Tablearay } from "../profile/Directoriesarray";
import social from "../assets/social.png";
import DataTable from "react-data-table-component";
import { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";

function ListTable(props) {
  console.log("prooops", props);
  const [allData, setAllData] = useState([]);
  const columns = [
    
    {
      name: "Business id/Website",
      selector: (row) => <div className="d-flex"><input type="radio" name="fav_language" value={row.id} className="business_radio4" onClick={()=>props.selectBusinessId(row.id)}/><div className="left-content">{row.id}<br></br><span>{row.website}</span></div>
      </div>,
      sortable: true,
    },
    {
      name: "Date Added",
      selector: (row) => row.created_at,
      sortable: true,
    },
    {
      name: "Business Name",
      selector: (row) => row.business_name,
      sortable: true,
    },
    {
      name: "Package Added/Expire",
      selector: (row) => row.business_name,
      sortable: true,
    },
    {
      name: "Street# / Name",
      selector: (row) => row.street_name,
      sortable: true,
    },
    {
      name: "State",
      selector: (row) => row.state,
      sortable: true,
    },
    {
      name: "City",
      selector: (row) => row.city1,
      sortable: true,
    },
    {
      name: "Zip",
      selector: (row) => row.city_zip,
      sortable: true,
    },
    {
      name: "Phone Number",
      selector: (row) => row.phone_number,
      sortable: true,
    },
    {
      name: "Actions",
      selector: (row) => (
        <div className="d-flex gap-2 align-items-center">
         <Link to={`/view/listing/${row.id}`}><img src={view} className="icon" /></Link> 
          <Link to={`/listing/update/${row.id}`}> <img src={edit} className="icon" /></Link>
         
          <img
            src={del}
            className="icon"
            onClick={() => props.delete(row.id)}
          />
        </div>
      ),
      sortable: true,
    },
  ];

  useEffect(() => {
    if (props.data != null) setAllData(props.data);
    
    
  }, [props.data]);

  return (
    <>
      <DataTable
        columns={columns}
        data={allData}

        pagination
        fixedHeader
        fixedHeaderScrollHeight="500px"
        defaultSortFieldId={1}
      />
    </>
  );
}

export default ListTable;
